import { combineReducers } from "redux";
import userReducer from "./userReducer";
import countriesReducer from "./countriesReducer";
import checkPinReducer from "./checkPinReducer";
import modalReducer from "./modalReducer";
import profileReducer from "./profileReducer";
import valueDriverReducer from "./valueDriverReducer";
import managmentReducer from "./managmentReducer";
import driverReducer from "./driverReducer";
import tripReducer from "./tripReducer";
import busyReducer from "./busyReducer";
import vehicleReducer from "./vehicleReducer";
import levelpathReducer from "./levelpathReducer";
import sublevelReducer from "./sublevelReducer";
import modelsReducer from "./modelsReducer";
import intlReducer from "./intlReducer";
import mapReducer from "./mapReducer";
import balanceReducer from "./balanceReducer";
import revenuesReducer from "./revenuesReducer";

const rootReducer = combineReducers({
  account: userReducer,
  countries: countriesReducer,
  checkpin: checkPinReducer,
  modal: modalReducer,
  profile: profileReducer,
  driver: valueDriverReducer,
  managment: managmentReducer,
  drivers: driverReducer,
  vehicles: vehicleReducer,
  trips: tripReducer,
  busy: busyReducer,
  levelpath: levelpathReducer,
  sublevel: sublevelReducer,
  models: modelsReducer,
  intl: intlReducer,
  map: mapReducer,
  balance: balanceReducer,
  revenues: revenuesReducer,
});

export type AppState = ReturnType<typeof rootReducer>;

export default rootReducer;
